import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import SubcategoriesCreateForm from './SubcategoriesCreateForm';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { createSubcategory } from 'store/actions/subcategories/createSubcategories';

class SubcategoriesCreateContainer extends React.Component {
    formatFormResults = (values) => {
        const {
            system,
        } = this.context.config.language;

        let baseValues = {
            category_id: values.category_id,
            ...values.localisation[system],
        };

        const localisationValues = utils.filterEmptyValues(values.localisation);

        return {
            base: baseValues,
            localisation: localisationValues,
        };
    }

    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
        } = this.props;

        if (utils.isEmpty(values)) {
            return null;
        }

        const convertedValues = this.formatFormResults(values);

        return new Promise((resolve, reject) => {
            return dispatchForm({
                onError: () => {
                    reject();
                },
                onSuccess: (response) => {
                    const {
                        id,
                    } = response;

                    resolve(history.push(`/subcategories/${ id }/show`));
                },
                formValues: convertedValues,
            });
        });
    }

    render() {
        const {
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.subcategories.title'),
                link: '/subcategories',
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.subcategories.actions.create') } />

                    <Actions>
                        <ListButton url='/subcategories' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <SubcategoriesCreateForm
                            form='subcategories_create'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

SubcategoriesCreateContainer.contextTypes = {
    config: PropTypes.object,
};

SubcategoriesCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createSubcategory(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(SubcategoriesCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/subcategories/create/SubcategoriesCreateContainer.js